import { useMutation, useQueryClient, type UseMutationOptions } from "react-query";
import { getPrivateApi } from "../../services/api";
import { type UpdateCatalogProductsRequestPayload } from "@vy/api-definition";
import { invalidateProductsQueries } from "../../utils/query-invalidation";

export function useUpdateCatalogProducts(
    options?: UseMutationOptions<
    void,
    unknown,
    { catalogProductId: string, updateCatalogProductsRequest: UpdateCatalogProductsRequestPayload }>,
) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ catalogProductId, updateCatalogProductsRequest }) => {
            const api = getPrivateApi();

            await api.updateCatalogProducts({
                catalogProductId,
                updateCatalogProductsRequest,
            });
        },
        onSuccess: async () => {
            await invalidateProductsQueries(queryClient);
        },
        ...options,
    });
}